import PartnersAndAcknowledgementsBanner from '@/components/Banners/PartnersAndAcknowledgementsBanner/PartnersAndAcknowledgementsBanner';
import Footer from '../Footer';

export const PublicFooter = () => {
  return (
    <>
      <PartnersAndAcknowledgementsBanner />
      <Footer />
    </>
  );
};
